import './styles/aui.pattern.forms';
import '@atlassian/aui/src/less/checkbox-multiselect.less';
export { default as CheckboxMultiselectEl } from '@atlassian/aui/src/js/aui/checkbox-multiselect';
